import { ConfigContext } from "contexts/ConfigProvider";

import { useContextHelper } from "./useContextHelper";

export default function useConfig() {
    return useContextHelper(ConfigContext, "ConfigContext");
}
